export const pagesProductsMapper = (data, callback) => {
  if (!data) return;

  let index = 0;
  data.pages.forEach((page) => {
    page.products.data.forEach((product) => {
      callback(product, index);
      index += 1;
    });
  });
};
export const pagesProductsMutator = (data, callback) => {
  if (!data) return data;

  let index = 0;
  return {
    ...data,
    pages: [
      ...data.pages.map((page) => ({
        ...page,
        products: {
          ...page.products,
          data: [
            ...page.products.data.map((product) => {
              index += 1;
              return callback(product, index - 1);
            }),
          ],
        },
      })),
    ],
  };
};
export const itemsProductsMapper = (data, callback) => {
  if (!data) return;

  data.items.forEach((item, index) => {
    if (item.product) {
      callback(item.product, index);
    } else if (item.sku) {
      callback({ sku: item.sku, price_and_stock: null }, index);
    }
  });
};

export const itemProductMapper = (data, callback) => {
  if (!data || typeof data !== 'object') return;

  if (data.product) {
    callback(data.product, 0);
  } else if (data.sku) {
    callback({ sku: data.sku, price_and_stock: null }, 0);
  }
};

export const itemProductMutator = (data, callback) => {
  if (!data || typeof data !== 'object') return data;

  let nextProduct = data.product;

  if (data.product) {
    nextProduct = callback(data.product, 0);
  } else if (data.sku) {
    nextProduct = callback({ sku: data.sku, price_and_stock: null }, 0);
  }

  return {
    ...data,
    product: nextProduct,
  };
};

export const itemProductsMutator = (data, callback) => {
  if (!data) return data;

  const nextItems = [];
  data.items.forEach((item, index) => {
    let nextProduct = item.product;
    if (item.product) {
      nextProduct = callback(item.product, index);
    } else if (item.sku) {
      nextProduct = callback({ sku: item.sku, price_and_stock: null }, index);
    }
    nextItems.push({
      ...item,
      product: nextProduct,
    });
  });

  return {
    ...data,
    items: nextItems,
  };
};
